import { LSStripe } from '../merchants/lsStripe.js';
import { LSCart } from '../cart.js';
import { LSCheckoutProcessor } from '../processor.js';
import { LSCheckout } from '../main.js';
import '../../css/main.css';
window.LSStripe = LSStripe;
window.LSCart = LSCart;
window.LSCheckoutProcessor = LSCheckoutProcessor;
window.LSCheckout = LSCheckout;